import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Content from 'nucleus-guestside-site/src/containers/Content';
import PlannerBanner from './PlannerBanner';
import TestModeBanner from './TestModeBanner';
import PreviewBanner from './PreviewBanner';
import PasskeyBanner from './passkeyBanner/PasskeyBanner';
import EventBuildWizardPreviewBanner from '../dialogs/EventBuildWizardPreviewBanner';
// eslint-disable-next-line no-unused-vars
import PageStyles from 'nucleus-guestside-site/src/containers/ResponsiveFontPage.less';
import { TEMPLATE_TOP_BOTTOM } from 'nucleus-widgets/renderers/shared/pageTypes';
import { openSharePromptDialog } from '../dialogs';
import { getRegistrationPathIdOrDefault } from '../redux/selectors/currentRegistrationPath';
import { getConfirmationNumber } from '../redux/selectors/currentRegistrant';
import { getIn } from 'icepick';
import { isPostRegistrationPage } from '../redux/website/registrationProcesses';

/**
* Custom page renderer implementation for the event guestside site.
*/
class PageRenderer extends React.Component {
  static displayName = 'PageRenderer';
  static propTypes = {
    page: PropTypes.object.isRequired,
    templatePage: PropTypes.object,
    isTestMode: PropTypes.bool,
    isPlanner: PropTypes.bool,
    isPreview: PropTypes.bool,
    showEventBuildWizardBanner: PropTypes.bool,
    isConfirmationPage: PropTypes.bool,
    confirmationNumber: PropTypes.string,
    openShareDialog: PropTypes.func,
    translate: PropTypes.func,
    sharePromptData: PropTypes.object
  };

  componentDidMount() {
    const {
      isConfirmationPage,
      confirmationNumber,
      openShareDialog,
      translate,
      sharePromptData
    } = this.props;

    if (isConfirmationPage
      && sharePromptData.allowSharePrompt
      && !localStorage.getItem(`sharePromptFor${confirmationNumber}`)
    ) {
      localStorage.setItem(`sharePromptFor${confirmationNumber}`, 1);
      openShareDialog(translate, sharePromptData);
    }
  }

  renderPage() {
    const { page, templatePage } = this.props;
    if (templatePage && templatePage.type === TEMPLATE_TOP_BOTTOM) {
      return (
        <div>
          <div role="banner">
            <Content rootLayoutItemId={templatePage.rootLayoutItemIds[0]} />
          </div>
          <div role="main" id="main" tabIndex="-1">
            <Content rootLayoutItemId={page.rootLayoutItemIds[0]} />
          </div>
          <Content rootLayoutItemId={templatePage.rootLayoutItemIds[1]} />
        </div>
      );
    }
    return (
      <div role="main" id="main" tabIndex="-1">
        <Content rootLayoutItemId={page.rootLayoutItemIds[0]} />
      </div>
    );
  }

  render() {
    const {
      isTestMode,
      isPlanner,
      isPreview,
      showEventBuildWizardBanner
    } = this.props;
    const renderedPage = this.renderPage();

    return (
      <div>
        <PasskeyBanner/>
        {!isPlanner && isTestMode && <TestModeBanner />}
        {isPlanner && <PlannerBanner />}
        {isPreview && showEventBuildWizardBanner && <EventBuildWizardPreviewBanner />}
        {isPreview && !showEventBuildWizardBanner && <PreviewBanner />}
        {renderedPage}
        <div role="contentinfo">
          <Content rootLayoutItemId="CventFooterContainer" />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const regPathId = getRegistrationPathIdOrDefault(state);
  const sharePromptSetting = getIn(state,
    ['appData', 'registrationSettings', 'registrationPaths', regPathId, 'sharePromptSetting']);
  const allowSharePrompt = getIn(state,
    ['appData', 'registrationSettings', 'registrationPaths', regPathId, 'allowSharePrompt']);

  // To fetch the contact stub from reg cart and base64 encode it so as to send it as a query param in Share Bar
  const eventRegs = getIn(state, ['registrationForm', 'regCart', 'eventRegistrations']);
  const eventReg = eventRegs ? eventRegs[Object.keys(eventRegs)[0]] : {};
  const encodedContactStub = getIn(eventReg, ['attendee', 'personalInformation', 'contactIdEncoded']);

  return {
    templatePage: state.website.pages[props.page.templateId],
    isTestMode: state.userSession.isTestMode,
    isPlanner: state.userSession.isPlanner,
    isPreview: state.userSession.isPreview,
    showEventBuildWizardBanner: state.userSession.showEventBuildWizardBanner,
    isConfirmationPage: isPostRegistrationPage(state, props.page.id),
    confirmationNumber: getConfirmationNumber(state),
    translate: state.text.translate,
    sharePromptData: {
      allowSharePrompt,
      sharePromptSetting,
      shareBarSettings: state.appData.shareBarSettings,
      shareSummaryURL: getIn(state, ['event', 'webLinks', 'linkName~Summary', 'shortUrl']),
      encodedContactStub
    }
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    openShareDialog: (translate, sharePromptData) => {
      dispatch(openSharePromptDialog(translate, sharePromptData));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PageRenderer);
